{
	"elementNofound": "Element for render no found",
	"byDay": "By day",
	"CalendarDay": "By days",
	"coverages": "Coverages",
	"transmission": "Transmission",
	"BasicPlus": "Total price",
	"Only": "Only car",
	"onlyCar": "Only car",
	"Basic": "Basic",
	"Full": "Total price + Fuel",
	"thisCoverageIncludes": "This coverage includes",
	"automatic": "Automatic",
	"manual": "Manual",
	"amountPassengers": "Passengers",
	"amountDoors": "Doors",
	"airConditioning": "Air conditioning",
	"amountBaggage": "Baggages",
	"theftProtectionPartial": "TP-Theft insurance(Partial)",
	"collisionDamageWaiver": "Collision damage waiver (CDW – TP)",
	"superCollisionDamageWaiver": "SCDW-Super Cover.",
	"personalAccidentInsurances": "PAI-Personal accident insurances.",
	"theftProtection": "TP-Theft protection.",
	"taxes": "Taxes",
	"insurances": "Insurances",
	"lowDamageWaiver": "LDW-Low damage waiver",
	"liabilitySupplementalInsurance": "LIS-Liability supplemental insurance",
	"secondDriver": "ADDDRV-2° Second driver",
	"fullGas": "GAS-Full Gas",
	"book": "Book",
	"dailyRateText": "Day",
	"yes": "Yes",
	"couldNotGetAgency": "Sorry, could not get agency.",
	"noResultsForSelectedDates": "The car rental service is not available in this destination.",
	"collisionDamageWaiverPartial": "CDW-Collision damage waiver (partial).",
	"selectYourDestination": "Select your destination",
	"dropOffLocation": "Drop off location",
	"addYourDestination": "Add your destination",
	"selectYourDates": "Select your dates",
	"labelDates": "Dates",
	"addYourDates": "Add your dates",
	"selectYourDiscount": "Select your discount",
	"withoutDiscount": "Without discount",
	"payOnLine": "Pay on line",
	"discounts": "Discounts",
	"discount": "Discount",
	"selectADiscount": "Select a discount",
	"haveMyOwnDiscount": "I have my own discount",
	"promotionalCode": "Promotional code",
	"selectApromotionalCode": "Select a promotional code",
	"haveMyOwnPromotionalCode": "I have my own promotional code",
	"hertzGold": "Hertz Gold ",
	"enterTheCodeHertzGold": "Enter your hertz code",
	"enterYourHertzGoldCodeHere": "enter your hertz gold code here",
	"add": "Add",
	"youSaveUpToDescription": "You save up to 30% by selecting this option.",
	"paymentOnArrival": "Payment on arrival",
	"startYourSearch": "Start your search",
	"returnTheCarInTheSamePlace": "Return the car in same place",
	"searchByLocations": "Search by locations",
	"selectHours": "Select hours",
	"pickup": "Pickup",
	"return": "Return",
	"delivery": "Delivery",
	"ready": "Ready",
	"enterADiscount": "Enter a discount",
	"enterAPromoCode": "Enter a promo code",
	"enterAPromocode": "Enter your promo code",
	"enterValidPromoCode": "Enter a valid promo code",
	"saveUpByAddingYourGoldHertzCode": "Save up to 30% by adding your Gold Hertz code",
	"next": "Next",
	"back": "Back",
	"finalize": "Finalize",
	"getBack": "Get Back",
	"viewDeal": "View deal",
	"airportList": "Airport List",
	"cityList": "City List",
	"selectYourDelivery": "Select your delivery",
	"selectYourHertzGold": "Select your Hertz Gold",
	"withoutHertzGold": "Without Hertz Gold",
	"noHertzGold": "Don't have Hertz Gold?",
	"addItHere": "Add it here",
	"select": "Select",
	"localities": "Localities",
	"localittiesNoFound": "Sorry, we couldn't find any results. We recommend you to search again with another city.",
	"results": "Results",
	"selectYourDiscounts": "Select your discounts",
	"weSorry": "We are sorry",
	"search": "Search",
	"returnTheCarInOtherPlace": "Return the car in other place",
	"first": "First",
	"economic": "Economic",
	"business": "Business",
	"economy": "Economy",
	"premiumEconomy": "Premium Economy",
	"premiumFirst": "Premium First",
	"premiumBusiness": "Premium Business",
	"allClassesLabel": "All classes",
	"origin": "Origin",
	"destination": "Destination",
	"passengersAndClass": "Passengers and Class",
	"selectTheClass": "Select the class",
	"adult": "Adult",
	"adults": "Adults",
	"adultsDescription": "Older than 12 years",
	"child": "Child",
	"children": "Children",
	"childrenDescription": "From 2 to 11 years old",
	"infant": "Infant",
	"infants": "Infants",
	"infantsDescription": "Between 0 and 2 years",
	"all": "All",
	"comeBack": "Come back",
	"roundTrip": "Round",
	"onewayTrip": "Oneway",
	"multiTrip": "Multi",
	"airline": "Airline",
	"searchTheAirline": "Search the airline",
	"onlyDirectFlights": "Only direct flights",
	"addFlight": "Add flight",
	"removeFlight": "Remove flight",
	"startYourFlightsSearch": "Start your search",
	"ageOfChild": "Age of Child",
	"adultsAndChildren": "Adults and Children",
	"room": "Room",
	"removeRoom": "Remove Room",
	"addRoom": "Add Room",
	"destinationsList": "List of destinations",
	"selectYourDate": "Select your date",
	"passengers": "Passengers",
	"passenger": "Passenger",
	"ageOfPassenger": "Age of passenger",
	"startYourHotelsSearch": "Start your search",
	"startYourActivitiesSearch": "Start your search",
	"howManyDays": "How many days in the parks?",
	"withPromoCode": "I have a promotional code",
	"promoCode": "Promotional code",
	"errorDateMinFlightMulti": "The date must be greater than the previous",
	"freeEntranceMessage": "Free entrance for children under 3 years (at the time of entering the park).",
	"adultsDisneyDescription": "Older than 10 years",
	"childrenDisneyDescription": "Between 3 and 9 years",
	"infantDisneyDescription": "Infants under 3 years enter the park for free",
	"Mundial": "Mundial",
	"Domestic": "National",
	"LATAM": "Latin America",
	"USA": "United States",
	"EU": "Europe",
	"childOrAdult": "Child or adults",
	"childrenOrAdults": "Children or adults",
	"childrenAndAdults": "Child and adults",
	"olderAdults": "Older adults",
	"olderAdult": "Older adult",
	"olderAdultsDescription": "Between 75 and 85 years",
	"childrenAndAdultsDescription": "Between 0 and 74 years",
	"annualCoverage": "Annual coverage",
	"CalendarAnnual": "Annual",
	"datesMessage": "Select a stay of maximum 28 days.",
	"parks": "Park",
	"allParks": "All Parks (Orlando)",
	"checkIn": "Date of admission",
	"checkOut": "Retirement date",
	"checkInLabel": "Check-in",
	"checkOutLabel": "Check-out",
	"one": "1",
	"two": "2",
	"addYourTicketsToPackages": "Add your tickets to parks",
	"selectDate": "Select the date of your ticket to know the total price",
	"days": "Days",
	"improveTicket": "Improve your ticket type",
	"VisitMultipleParks": "Visit one park or multiple parks per day, multiple parks with more added fun!",
	"entrance": "Entrance",
	"price": "Price",
	"nights": "Nights",
	"plusSign": "+",
	"packages": "packages",
	"of": "of",
	"taxesFees": "Taxes and fees: Included",
	"disney": "disney",
	"reservationDetails": "Reservation details",
	"reserve": "Reserve",
	"addonsAlert": "Sorry, we currently have no parks available for your selection; Please try another day to enter the park.",
	"selectYourNationality": "Select your nationality",
	"country": "Country",
	"searchYourCountry": "Search your country",
	"startDisneyExperience": "Start your Disney Experience",
	"buyYourStandardTickets": "Buy your standard tickets or choose",
	"moreOptionsToEnjoy": "more options to enjoy your stay",
	"theMoreDaysYouChoose": "The more days you choose, the less you will pay per day.",
	"rememberCheckAvailabilityParks": "Remember to check the availability of the Parks before buying",
	"seeCalendar": "See calendar",
	"class": "Class",
	"passengersAndAirlines": "Passengers & airlines",
	"optionalLabel": "Optional",
	"requiredField": "Complete this field",
	"requiredFieldOrigin": "The origin field is required",
	"requiredFieldDestination": "The destination field is required",
	"requiredFieldDates": "The dates field is required",
	"requiredFieldPickup": "The pickup field is required",
	"requiredFieldReturn": "The return field is required",
	"invalidStayLength": "Select at least one night",
	"completeField": "Complete the field",
	"cancel": "Cancel",
	"apply": "Apply",
	"selectAnOrigin": "Select an origin",
	"selectOrigin": "Select origin",
	"selectADestination": "Select a destination",
	"selectDestination": "Select destination",
	"selectAnOption": "Select an option",
	"maximumAgeRestrictionMessageForChildren": "The value must be equal to/less than 17",
	"messageMinimumAgeRestrictionForChildren": "The value must be equal to/greater than 1",
	"points": "Points",
	"consultMyPoints": "Consult my points",
	"inputYourData": "Enter the data of your",
	"bacCreditCard": "BAC credit card",
	"forConsultingPoints": "to check how many points or miles you have accumulated.",
	"cardHolderName": "Cardholder name",
	"cardNumber": "Card number",
	"expirationDate": "Expiration date",
	"cvc": "CVC",
	"consulting": "Consulting...",
	"consult": "Consult",
	"availableKey": "available",
	"toConsultPoints": "To check your points or miles,",
	"mustEnterData": "you must enter a BAC credit card.",
	"consultedCreditCard": "Consulted credit card",
	"close": "Close",
	"consultAnotherCard": "Consult another card",
	"clearConsult": "Clear query",
	"clearConsultTitle": "Clear the entire query?",
	"clearConsultMessage": "The queried cards will be removed from the browser.",
	"confirmClear": "Yes, clear",
	"allDone": "All done",
	"clearDoneMessage": "We cleared your query data. You can keep exploring options for your trip.",
	"continueBrowsing": "Continue browsing",
	"carsDisclaimer": "At the moment this service is not available for national destinations",
	"ticketsForSpecialEvents": "Tickets for Special Events",
	"buyNow": "Buy now",
	"selectYourPassengers": "Select your passengers",
	"betweenOneAndSeventeenYears": "Between 1 and 17 years",
	"overEighteenYears": "Over 18 years",
	"flight": "Flight",
	"addAnotherFlight": "Add another flight",
	"searchFlights": "Search flights",
	"remove": "Remove",
	"whereTravel": "Where are you traveling to?",
	"whenTravel": "When are you travelling?",
	"travelFrom": "I travel from",
	"travelTo": "I travel to",
	"departureDate": "Departure date",
	"startDateLabel": "Start",
	"returnDate": "Return date",
	"endDateLabel": "End",
	"selected": "Selected",
	"addMealPlan": "Add your meal plan",
	"mealPlan": "Meal plan",
	"ticket": "Ticket",
	"mealPlanHighlights": "Meal Plan Highlights",
	"roomOnly": "Room only",
	"three": "3",
	"planIncluded": "Plan included",
	"verifyInformation": "To continue, please verify the following information:",
	"verifyStatusCard": "• Validate the status of your card.",
	"validateCardAffiliated": "• Verify that your card is enrolled in a points or miles loyalty program.",
	"checkCardAgain": "Check your card again ",
	"contactCustomer": "or contact BAC customer service for more information.",
	"unableVerifyCard": "We were unable to verify the entered card",
	"guests": "Guests",
	"departingDate": "Departure date",
	"hour": "Hour",
	"deliveryDate": "Delivery date",
	"pickupDate": "Pickup date",
	"cities": "Cities",
	"airports": "Airports",
	"seeAllLocations": "See all locations",
	"selectPickup": "Select pickup",
	"selectReturn": "Select return",
	"selectPluralDates": "Select dates",
	"visitors": "Visitors",
	"adultsDescriptionHotels": "Equal or over 18 years old",
	"childrenDescriptionHotles": "from 1 to 17 years",
	"selectSingularDate": "Select date",
	"age": "Age",
	"selectPassengers": "Select passengers",
	"selectGuests": "Select guests",
	"childrenLessOneYearMsg": "Babies under one year old do not need to be registered.",
	"pluralOverEighteenYears": "Over 18 years",
	"pluralBaby": "Babies",
	"singularBaby": "Baby",
	"sinceTwelveYears": "From 12 years",
	"rooms": "Rooms",
	"followUs": "follow us on",
	"loginCME": "Login in",
	"availabilitySearchesUpcomingMonths": "Searches are only available within the next 12 months.",
	"searchNotAllowed": "Sorry, search not allowed",
	"youAreSearchingForADisallowedSeason": "You are searching for a disallowed season",
	"ok": "OK",
	"bookingConditionsNotCompliant": "The booking conditions do not comply with the program policies",
	"learnMoreAt": "Learn more at",
	"termsAndConditions": "Terms and conditions",
	"recentSearches": "Recent searches",
	"removeAll": "Remove all",
	"assistants": "Assistants",
	"assistances": "Assistances",
	"freeEntranceDescription": "Free entrance for children under 3 years old. You will not be charged for the child when entering the park.",
	"minTotalPassengersNotCompliant": "You must select at least {{min}} passengers",
	"yourCertificateIsNotValidForTheSelectedDates": "The reservation conditions do not comply with the program policies",
	"ageOfAssistant": "Age of assistant",
	"loginPromerica": "Login",
	"selectCountry": "Select your country",
	"titleFooterSectionPromericaMobile": "Download our App",
	"descriptionSectionMobilePromericaFooter": "Book your trips easily and quickly from your mobile device with the Promerica App.",
	"descriptionPromericaFooter": "Personalize your experience with our Promerica Club App.",
	"accept": "Accept",
	"minutes": "Minutes",
	"hours": "Hours",
	"searchPromerica": "Search",
	"childrenThreeToNineYears": "From 3 to 9 years old",
	"threeToNineYears": "3 to 9 years old",
	"selectTheAge": "Select the age",
	"twelveYearsAndUp": "12 years and up",
	"tenYearsAndUp": "10 years and up",
	"journey": "Journey",
	"flights": "Flights",
	"chooseRoute": "Choose your route",
	"chooseOrigin": "Choose the origin",
	"chooseDestination": "Choose the destination",
	"choosePassengers": "Choose passengers",
	"whereDoYouWantToGo": "Where do you want to go?",
	"whereDoYouWantToTravel": "Where do you want to travel?",
	"startSearch": "Start your search",
	"childrenDescriptionInfo": "Flights with minors have special conditions. Children must travel accompanied by an adult.",
	"infantsDescriptionInfo": "The infant can only travel on the adult's lap. If you want to assign a seat, you must add them as a child.",
	"childrenDescriptionsHotels": "Minors must stay accompanied by an adult.",
	"sinceEighteenYears": "From 18 years",
	"sinceEighteenYearsModern": "18 years and older",
	"upToSeventeenYears": "From 0 to 17 years",
	"night": "Night",
	"hotels": "Hotels",
	"chooseGuests": "Select the guests",
	"whereDoYouWantToStay": "Where do you want to stay?",
	"hotelList": "Hotel List",
	"deliveryDateTime": "Delivery date and time",
	"nationality": "Nationality",
	"whereDoYouWantToDrive": "Where do you want to drive?",
	"cars": "Cars",
	"datesMessageProductCars": "Select a rental of up to 62 days",
	"deliverCarInOtherPlace": "Deliver car in another location",
	"pickupLocation": "Pickup location",
	"dropOffLocationModern": "Drop-off location",
	"dropOffLocationShort": "drop-off",
	"pickupAndDropOffLocation": "Pickup and drop-off location",
	"hertzGoldCodeModern": "Hertz Gold code",
	"hertzGoldPlaceholderModern": "Enter Hertz Gold code",
	"hertzGoldSecondPlaceholderModern": "Enter Hertz Gold code",
	"discountCodeModern": "Discount code",
	"discountPlaceholderModern": "Select your discount code",
	"ageOfBoy": "Age of the boy",
	"whatExperienceDoYouWantToLive": "What experience do you want to live?",
	"fromOneToSeventeenYearsOld": "1 to 17 years old",
	"activities": "Activities",
	"TitleActivitiesInMobile": "Activities",
	"selectYourDatesInMobile": "Select your dates",
	"labelDatepicker": "Dates",
	"selectYourAssistantsInMobile": "Select your assistants",
	"disneyMobileSearchTitle": "How would you like to enjoy it?",
	"disneyLabelMobile": "Disney",
	"disneySearchDisclaimer": "Your search will be performed across all Hotels Disney available in Orlando",
	"freeEntranceTitle": "Free admission for children under 3",
	"freeEntranceSubtitle": "Upon entering the park.",
	"enterDestination": "Enter the destination",
	"popularDestinations": "Popular Destinations",
	"selectAgeForEachChild": "Select the age of each child",
	"labelCityOrHotelName":"City or hotel name",
	"labelSelectYourDateAndTime":"Select your date and time",
	"minute": "Minute",
	"directFlights": "Direct flights",
	"hertzCode": "Hertz Code",
	"enterYourCodeHere": "Enter your code here",
	"year": "year",
	"years": "years",
	"visitor": "Visitor"
}
